var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Transform, Type } from "class-transformer";
import { StudioProjectAttributesV2NodeDataEdgeIndexRef, StudioProjectAttributesV2NodeDataNodeIndexRef, } from "./StudioProjectAttributesV2Node";
import { JsonUtil } from "../../cutil/JsonUtil";
import isBlank from "@sedan-utils/is-blank";
export const uploadFileTypes = [
    "uploadFile",
    "uploadImage",
    "baseVideo",
    "unStructured",
    "table",
    "pdfFile",
    "audio",
    "imageGen",
    "imageSearch",
    "midjourney",
    "midjourneyV2",
    "html",
];
export const nonTextTypes = uploadFileTypes.concat([
    "jdShopping",
    "stockInfo",
    "amazonShopping",
    "weeeShopping",
    "map",
    "video",
    "json",
    "imageGen",
    "midjourney",
    "midjourneyV2",
    "imageSearch",
]);
export const textTypes = ["text", "askBrain"];
export class StudioProjectAttributesV3NodeData {
}
__decorate([
    Type(() => StudioProjectAttributesV2NodeDataNodeIndexRef)
], StudioProjectAttributesV3NodeData.prototype, "nodeIndexRef", void 0);
__decorate([
    Type(() => StudioProjectAttributesV2NodeDataEdgeIndexRef)
], StudioProjectAttributesV3NodeData.prototype, "edgeIndexRef", void 0);
__decorate([
    Transform(({ value, obj }) => {
        if (obj.displayType === "imageGen") {
            return JsonUtil.toModelFromType(StudioProjectV3ImageValue, value);
        }
        else if (obj.displayType === "stockInfo") {
            return JsonUtil.toModelFromType(StudioProjectV3StockValue, value);
        }
        else if (obj.displayType === "customJsFunction" && !isBlank(value.type)) {
            return JsonUtil.toModelFromType(StudioProjectV3ProteinValue, value);
        }
        else if (uploadFileTypes.includes(obj.displayType)) {
            return JsonUtil.toModelFromType(StudioProjectV3FileValue, value);
        }
        return value;
    }, { toClassOnly: true })
], StudioProjectAttributesV3NodeData.prototype, "textAreaValue", void 0);
export class StudioProjectV3TextAreaValue {
}
export class StudioProjectV3ImageValue extends StudioProjectV3TextAreaValue {
}
export class StudioProjectV3StockValue extends StudioProjectV3TextAreaValue {
}
export class StudioProjectV3ChatInterfaceValue extends StudioProjectV3TextAreaValue {
}
export class StudioProjectV3InterviewBotValue extends StudioProjectV3TextAreaValue {
}
export class StudioProjectV3AskBrainValue extends StudioProjectV3TextAreaValue {
}
export class StudioProjectV3ShoppingValue extends StudioProjectV3TextAreaValue {
}
export class StudioProjectV3CustomApiValue extends StudioProjectV3TextAreaValue {
}
export class StudioProjectV3ProteinValue extends StudioProjectV3TextAreaValue {
}
export class StudioProjectV3YoutubeValue extends StudioProjectV3TextAreaValue {
}
export class StudioProjectV3FoodValue extends StudioProjectV3TextAreaValue {
}
export class StudioProjectV3MidjourneyValue extends StudioProjectV3TextAreaValue {
}
export class StudioProjectV3FileValue extends StudioProjectV3TextAreaValue {
}
__decorate([
    Type(() => StudioProjectV3FileValueFile)
], StudioProjectV3FileValue.prototype, "file", void 0);
__decorate([
    Type(() => StudioProjectV3FileValuePercent)
], StudioProjectV3FileValue.prototype, "percent", void 0);
export class StudioProjectV3FileValueFile {
}
export class StudioProjectV3FileValuePercent {
}
export class StudioProjectV3MapValue extends StudioProjectV3TextAreaValue {
}
export class StudioProjectV3UploadFileValue extends StudioProjectV3TextAreaValue {
}
